export default "__VITE_ASSET__DIZt$iPw__"